if(!customElements.get('ingredients-items')) {
  class ComponentIngredients extends HTMLElement {
    constructor() {
      super();
      this.carousel = this.querySelector('.component-carousel');
      var mqS = window.matchMedia("(max-width: "+window.breakpoints.medium+")");
      var isMobile = false;

      setTimeout(()=>{ //The timeout is for the customizer
        $s.resizeWidthHandle(()=>{
          if(mqS.matches){
            if(!isMobile) 
              this.carousel.initSlider();
          }
          else{
            if(isMobile)
              this.carousel.removeSlider();
            
          }
        isMobile = mqS.matches;
        });
      }, 1);
    }
  }
  customElements.define('ingredients-items', ComponentIngredients);
}